import { Component, signal } from "@angular/core";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { ICellRendererAngularComp } from "ag-grid-angular";
import type { ICellRendererParams } from 'ag-grid-community';

export interface IIconCellRendererParams {
    style:string|undefined;
    icon:string|undefined;
}

@Component({
    selector: 'app-icon-renderer',
    standalone: true,
    template: `
        <span class="d-flex flex-column align-items-center justify-content-center h-100">
            @if(data()){
                <fa-icon [icon]="[style(), icon()]"/>
            }
            @else {
                <span class="d-flex flex-row w-100 border-radius-small overflow-hidden placeholder-icon">
                    <span class="bg-placeholder"></span>
                </span>
            }
        </span>
    `,
    imports: [FaIconComponent],
})
export class IconCellRendererComponent implements ICellRendererAngularComp {
    data = signal<any|undefined>(undefined);
    style = signal<string>('fas');
    icon = signal<string>('box');

    agInit(params: ICellRendererParams & IIconCellRendererParams): void {

        this.data.set(params.data);

        if(params.style){
            this.style.set(params.style);
        }
        if(params.icon){
            this.icon.set(params.icon);
        }
    }

    refresh(params: ICellRendererParams): boolean {
        return false;
    }
}